<template>
  <div>
    <footer class="footer-component">
      <div class="container">
        <div class="footer-component_row">
          <logo-link class="footer-component_logo"/>
          <inline-menu
            class="footer-component__main-menu"
            dark_menu
            hidden_children
            :menus="footer_menu_main"/>
          <language-switcher
            class="footer-component__lang-switcher"
            dark
            dropdown_top/>
        </div>
        <div class="footer-component__social-links">
          <hr class="footer-component__social-links-line"/>
          <div class="footer-component__social-links-block">
            <social-links/>
          </div>
        </div>
        <div class="footer-component_lower-block">
          <footer-secondary-menu
            class="footer-component_lower-block_menu"
            :menus="footer_secondary_menu"/>
          <copyrights class="footer-component_lower-block_copyright"/>
        </div>
      </div>
    </footer>
    <cookie-modal/>
  </div>
</template>

<script>
import InlineMenu from "../small_parts/InlineMenu.vue";
import LogoLink from "../small_parts/LogoLink.vue";
import LanguageSwitcher from "../small_parts/LanguageSwitcher.vue";
import SocialLinks from "./footer/SocialLinks.vue";
import Copyrights from "../small_parts/Copyrights.vue";
import FooterSecondaryMenu from "./footer/FooterSecondaryMenu.vue";
import CookieModal from "../modals/CookieModal.vue";

export default {
  name: 'FooterComponent',
  components: {
    CookieModal,
    FooterSecondaryMenu,
    Copyrights,
    SocialLinks,
    LanguageSwitcher,
    LogoLink,
    InlineMenu
  },
  computed: {
    footer_menus() {
      return this.$context?.footer_menus || []
    },
    footer_menu_main() {
      return this.footer_menus[0]?.menus || []
    },
    footer_secondary_menu() {
      return this.footer_menus[1]?.menus || []
    },
  }
}
</script>
